import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { RewardsStateModel } from '@swf/core/types/RewardsLegacy';

import styles from './StarsRewards.scss';
import Nudge from './components/Nudge/Nudge';
import OptIn from './components/Optin/Optin';
import RewardsContainer from './components/RewardsContainer/RewardsContainer';

export interface Props {
  expanded?: boolean;
}

const handlerClass = 'stars-rewards-handler';

const StarsRewards: React.FC<Props> = ({ expanded }) => {
  const [dropDownVisible, setdDopDownVisible] = useState(false);
  const hidePanelTimer = useRef<number>(undefined);
  const isTouch = useRef(false);
  const license = useSelector(select.account.getLicense);
  const rewards = useSelector(select.rewardsLegacy.get);
  const { userOptedIn, userExcluded } = rewards;

  const hidePanel = useCallback(() => {
    setdDopDownVisible(false);
  }, []);

  const showPanel = useCallback(() => {
    // clear timeout in case it was enabled
    if (hidePanelTimer.current) {
      window.clearTimeout(hidePanelTimer.current);
      hidePanelTimer.current = undefined;
    }
    setdDopDownVisible(true);
  }, []);

  const togglePanel = useCallback(() => {
    setdDopDownVisible(!dropDownVisible);
    isTouch.current = false;
  }, [dropDownVisible]);

  const mouseEnterShowPanel = useCallback(() => {
    if (!isTouch.current) {
      showPanel();
    }
  }, [showPanel]);

  const mouseLeaveHidePanel = useCallback(() => {
    hidePanelTimer.current = window.setTimeout(hidePanel, 100);
  }, [hidePanel]);

  const setTouch = useCallback(() => {
    isTouch.current = true;
  }, []);

  if (isEmpty(rewards) || userExcluded || license === LicenceId.SE) {
    return null;
  }

  return (
    <div className={styles.starsRewards}>
      {userOptedIn ? (
        <RewardsContainer
          rewards={rewards as RewardsStateModel}
          clickOutside={hidePanel}
          outsideClickIgnoreClass={handlerClass}
          onMouseEnter={mouseEnterShowPanel}
          onMouseLeave={mouseLeaveHidePanel}
          expanded={expanded}
          className={classNames(handlerClass, styles.rewardsContainer)}
          dropDownVisible={dropDownVisible}
          onTouchStart={setTouch}
          onClick={togglePanel}
        />
      ) : (
        <OptIn expanded={expanded}>
          <Nudge />
        </OptIn>
      )}
    </div>
  );
};

export default StarsRewards;
